import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  MUTATE_SET_ACTIVE_TRACK_MAP,
  QUERY_AVAILABLE_CIRCUITS,
  QUERY_AVAILABLE_CONFIGURATIONS_FOR_CIRCUIT,
  QUERY_TRACK_MAP,
  QUERY_TRACK_MAP_FOR_PREVIEW,
  SUBSCRIBE_NEW_ACTIVE_TRACK_MAP,
} from "../queries/trackMapQueries";
import {
  setTrackMap,
  setTrackMapPreview,
  setAvailableCircuits,
  setAvailableConfigurationsForCircuit,
} from "../../../state/trackMapReducer";

export function QueryActiveTrackMap() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_TRACK_MAP);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setTrackMap(data.getActiveTrackMap));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryAvailableCircuits() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_AVAILABLE_CIRCUITS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setAvailableCircuits(data.getAvailableCircuits));
    }
  }, [dispatch, data, loading, error]);
}

export function QueryAvailableConfigurationsForCircuit() {
  const dispatch = useDispatch();
  const [queryAvailableConfigurationsForCircuit, { data, loading, error }] =
    useLazyQuery(QUERY_AVAILABLE_CONFIGURATIONS_FOR_CIRCUIT);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(
        setAvailableConfigurationsForCircuit(
          data.getAvailableConfigurationsForCircuit,
        ),
      );
    }
  }, [dispatch, data]);
  return {
    queryAvailableConfigurationsForCircuit: (circuitID: string) =>
      queryAvailableConfigurationsForCircuit({ variables: { circuitID } }),
    loading,
    error,
  };
}

export function QueryTrackMapPreview() {
  const dispatch = useDispatch();
  const [queryTrackMapPreview, { data, loading, error }] = useLazyQuery(
    QUERY_TRACK_MAP_FOR_PREVIEW,
  );
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setTrackMapPreview(data.getTrackMapForPreview));
    }
  }, [dispatch, data]);
  return {
    queryTrackMapPreview: (variables: {
      circuitName: string;
      circuitID: string;
      configurationName: string;
      configurationID: string;
    }) => queryTrackMapPreview({ variables }),
    loading,
    error,
  };
}

export function MutateSetActiveTrackMap() {
  const [setActiveTrackMap] = useMutation(MUTATE_SET_ACTIVE_TRACK_MAP);
  return setActiveTrackMap;
}

export function SubscribeNewActiveTrackMap() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_ACTIVE_TRACK_MAP, {
    onData: (x) => {
      const newTrackMap = x.data.data.newActiveTrackMap;
      dispatch(setTrackMap(newTrackMap));
    },
  });
  if (error) {
    console.log(error);
  }
}
